/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Text from "../ui/Text";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/Table";
import { useNavigate } from "react-router-dom";
import InvoiceStatusBadge from "../InvoiceStatusBadge";
import FormatPrice from "../formatters/FormatPrice";
import FormatDateTime from "../formatters/FormatDateTime";
import { getInvoiceRoute } from "../../utils/helpers/invoice";

const ClientInvoicesTable = ({ invoices }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>invoice #</TableHead>
          <TableHead>invoice_date</TableHead>
          <TableHead>invoice_payment_processor</TableHead>
          <TableHead>invoice_total_amount</TableHead>
          <TableHead>invoice_payment_received</TableHead>
          <TableHead align="center">status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {invoices.map((invoice) => (
          <ClientInvoicesTableRow key={invoice.id} invoice={invoice} />
        ))}
      </TableBody>
    </Table>
  );
};

const ClientInvoicesTableRow = ({ invoice }) => {
  const navigate = useNavigate();

  const route = getInvoiceRoute(invoice);
  const handleRowClick = () => route && navigate(route);

  return (
    <TableRow key={invoice.number} clickable onClick={handleRowClick}>
      <TableCell>
        <Text color="dark">{invoice.number}</Text>
      </TableCell>
      <TableCell>
        <Text color="dark">
          <FormatDateTime value={invoice.datetime} format={FormatDateTime.FORMAT.DATETIME} />
        </Text>
      </TableCell>
      <TableCell>
        <Text color="dark">{invoice.payment_processor}</Text>
      </TableCell>
      <TableCell>
        <Text color="dark">
          <FormatPrice value={invoice.amount} currency={invoice.currency} />
        </Text>
      </TableCell>
      <TableCell>
        <Text color="dark">{invoice.payment_received ? "yes" : "no"}</Text>
      </TableCell>
      <TableCell align="center">
        <InvoiceStatusBadge status={invoice.status} payment_received={invoice.payment_received} />
      </TableCell>
    </TableRow>
  );
};

export default ClientInvoicesTable;
